module.exports = __webpack_public_path__ + "img/icon-on-site-at-your-event.7c85f189.png";